import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from 'shared/routes';

export const Route = createFileRoute('/_authenticated/account/')({
  beforeLoad: () => {
    throw redirect({ to: routes.account(), replace: true });
  }
});
